export enum DoNotShowAgainKeys {
  NC_DELETE_BUCKET = 'nc.bucket',
  NC_MARK_TYPE_AS_READ = 'nc.mark_type_as_read',
  NC_MOVE_SELECTION = 'nc.move_selection',
  NC_MARK_SELECTION_AS_UNREAD = 'nc.mark_selection_as_unread',
  NC_MARK_ALL_READ = 'nc.mark_all_read',
}

export enum CloseOnConfirmOption {
  CloseOnCancelOnly = 'cancel-only',
  DontClose = 'dont-close',
}
